import { useState, type DragEvent } from 'react';
import { UploadIcon } from '@/ui/icons';
import styles from './DropZone.module.css';
import { ACCEPT } from './validate';

interface DropZoneProps {
  onFile: (file: File) => void;
}

/** The whole zone is a drop target and opens the file picker (F1.1, design: Library hero). */
export function DropZone({ onFile }: DropZoneProps) {
  const [dragging, setDragging] = useState(false);

  const onDrop = (e: DragEvent<HTMLLabelElement>) => {
    e.preventDefault();
    setDragging(false);
    const file = e.dataTransfer.files[0];
    if (file) onFile(file);
  };

  return (
    <label
      className={styles.zone}
      data-dragging={dragging || undefined}
      onDragOver={(e) => {
        e.preventDefault();
        setDragging(true);
      }}
      onDragLeave={() => {
        setDragging(false);
      }}
      onDrop={onDrop}
    >
      <input
        className={styles.input}
        type="file"
        accept={ACCEPT}
        aria-label="Choose an audio or video file"
        onChange={(e) => {
          const file = e.target.files?.[0];
          e.target.value = '';
          if (file) onFile(file);
        }}
      />
      <span className={styles.iconTile}>
        <UploadIcon size={28} />
      </span>
      <span className={styles.title}>
        {dragging ? 'Drop to analyze' : 'Drag an audio or video file here'}
      </span>
      <span className={styles.choose} aria-hidden="true">
        or choose a file
      </span>
      <span className={styles.formats}>
        MP3, WAV, M4A/AAC — plus OGG, FLAC, MP4 and WebM when your browser can decode them
      </span>
    </label>
  );
}
